import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
import { GridSamplingStrategyKind } from "./GridSamplingStrategy";
/**
 * Convert a GenericGeoJsonRequest into its transferable form.
 */
export function GenericGeoJsonRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area?.toTransferable(),
        boundingBoxLimit: req.boundingBoxLimit ? req.boundingBoxLimit.toTransferable() : null,
        datetime: req.datetime ? DateTime_toTransferable(req.datetime) : undefined,
    };
}
/**
 * Rehydrate a transferable request received from the worker.
 */
export function GenericGeoJsonRequest_fromTransferable(req) {
    return {
        ...req,
        area: req.area ? Area.fromTransferable(req.area) : undefined,
        boundingBoxLimit: req.boundingBoxLimit ? Area.fromTransferable(req.boundingBoxLimit) : null,
        datetime: req.datetime ? DateTime_fromTransferable(req.datetime) : undefined,
    };
}
/**
 * Helper to map the generic request into a GridRequest shape so existing bbox
 * utilities (e.g. `recalculateBBox`) can be reused without code duplication.
 *
 * We set `sampling.kind` to `Point` because GeoJSON endpoints are not sampled
 * onto a numerical grid and several helpers treat Point as the neutral option.
 */
export function GenericGeoJsonRequest_toGridRequest(request) {
    return {
        ...request,
        parameters: [],
        sampling: { kind: GridSamplingStrategyKind.Point },
    };
}
//# sourceMappingURL=GenericGeoJsonRequest.js.map